<template>
  <div class="civii-card">
    <div v-if="title" class="civii-card-title">{{title}}</div>
    <hr v-if="title" class="civii-card-line">
    <div class="civii-card-content">
      <content-render :content="content"/>
    </div>
    <action-buttons v-if="Array.isArray(buttons) && buttons.length > 0"
      :buttons="buttons"
    />
  </div>
</template>

<script>
import ContentRender from '../../widgets/ContentRender/ContentRender.js'
import ActionButtons from '../../widgets/ActionButtons/ActionButtons.vue'

export default {
  components: {
    'action-buttons': ActionButtons,
    'content-render': ContentRender
  },
  props: ['title', 'content', 'buttons']
}
</script>



// WEBPACK FOOTER //
// src/components/answers/Card/Card.vue